import makeCrud from '@/store/site/localization/crud'

// Tedarikçi CRUD'u standart sayfalı liste sözleşmesini (data + meta) kullanır,
// çeviri/dil boyutu yoktur → ortak CRUD store fabrikası yeterli.
export default makeCrud('ecommerce_product_supplier')
